module.exports = __webpack_public_path__ + "static/media/3.4de85efb.png";